/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const yereyere: CommunityData = {
  code: "yereyere",
  inviteCode: "yereyere",
  name: "Yereyere",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/yereyere`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      logo: {
        src: "/assets/customizations/yereyere/logo-2.png",
        styles: "w-[122px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/yereyere/logo.png",
        styles: "w-[122px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#FFFFFF]",
      bgColor: "#000000",
      asideBg: "#040608",
      asideStyles: "border-r-[#FFFFFF] border-r",
      contentBg: "#040608",
      bgDesktop: "/assets/customizations/yereyere/bg.png",
      bgMobile: "/assets/customizations/yereyere/bg.png",
      mainFont: "font-['NeueHaasDisplay']",
      primaryButton:
        "flex mt-2 font-black font-['Swiss'] rounded-full text-bold justify-center items-center !text-[16px] pt-1 !h-[52px] bg-[#000000] border-[#FFFFFF] border-[1px] !px-[32px] !text-[#FFFFFF] sm:!min-w-[156px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#FFFFFF] border-t",
      item: "text-[16px] uppercase font-black font-['Swiss'] text-[#FFFFFF] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[20px] uppercase font-black font-['Swiss'] text-[#FFFFFF] leading-[40px]",
      announcements: {
        lg: {
          title:
            "!text-[10px] font-black font-['Swiss'] -mb-1 mt-[-4px] px-[6px] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[12px] px-[6px] !bg-[#000000] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
        sm: {
          title:
            "!text-[10px] font-black font-['Swiss'] mb-1 mt-[-4px] px-[6px] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[12px] px-[6px] !bg-[#000000] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
      },
      event: {
        title: "text-[16px] text-[#FFFFFF] one-line-truncate font-black font-['Swiss']",
        subtitle: "text-[#FFFFFF] text-[12px] leading-[14px]",
      },
      shop: {
        title: "text-[16px] uppercase text-[#FFFFFF] font-black font-['Swiss']",
        text: "text-[#FFFFFF] text-[12px] leading-[14.4px]",
        customShopImage: "",
      },
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    announcements: {
      created: "text-[#FFFFFF] text-[14px] leading-[17px]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[20px] uppercase font-black font-['Swiss'] text-[#FFFFFF] leading-[40px]",
      title: "!text-[16px] font-black font-['Swiss'] text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[17px]",
    },
    announcement: {
      likeCount: "text-[#FFFFFF]",
      commentCount: "text-[#FFFFFF]",
      created: "text-[#FFFFFF] text-[14px] leading-[17px]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "!text-[16px] font-black font-['Swiss'] text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[17px]",
      commentIconColor: "#FFFFFF",
      likeIconColor: "#FFFFFF",
    },
    events: {
      sectionHeader: "text-[20px] text-[#FFFFFF] font-bold",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[40px] font-bold text-[#FFFFFF]",
      title: "text-[20px] font-bold text-[#FFFFFF]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      duration: "mb-4 text-[#FFFFFF] text-[14px] leading-[16px]",
      address: "text-[#FFFFFF] text-[14px] leading-[16px]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#FFFFFF]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      header:
        "text-[20px] font-black font-['Swiss'] uppercase leading-[45px] text-[#FFFFFF] !mt-0 sm:mb-0 mb-[24px]",
      sectionTitle: "text-[16px] font-black font-['Swiss'] leading-[20px] text-[#FFFFFF]",
      sectionSubtitle: "text-[#FFFFFF] !text-[14px] leading-[17px]",
      text: "text-[#FFFFFF] text-[14px] leading-[17px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#FFFFFF]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#FFFFFF] overflow-hidden",
        pinColor: "#FFFFFF",
        strokeColor: "#FFFFFF",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title:
          "!mt-0 text-[20px] font-black font-['Swiss'] leading-[45px] uppercase text-[#FFFFFF]",
        subtitle: "text-[#FFFFFF] !text-[14px] leading-[17px]",
      },
      ticket: {
        title: "text-[16px] font-black font-['Swiss'] text-[#FFFFFF]",
        description: "font-['NeueHaasDisplay'] text-[#FFFFFF] text-[14px] leading-[17px]",
        text: "opacity-[70%] font-['NeueHaasDisplay'] text-[#FFFFFF] text-[14px] leading-[17px]",
        price: "text-[16px] text-[#FFFFFF] font-black font-['Swiss']",
        counterContainer: "text-[20px] !text-[#000] !border-[#FFFFFF]",
        quantity:
          "text-nowrap text-[#FFFFFF] text-[16px] !border-[#FFFFFF] font-black font-['Swiss']",
      },
      separator: "sm:my-8 my-6 border-b-[#FFFFFF] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['Gramatika'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/yereyere/bg.png",
      bgMobile: "/assets/customizations/yereyere/bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#FFFFFF] border-[2px]",
        name: "text-[32px] mt-2 text-[#FFFFFF] uppercase font-black font-['Swiss']",
        location: "text-[14px] font-['NeueHaasDisplay'] opacity-[80%] text-[#FFFFFF] mb-2",
        description:
          "text-[14px] font-['NeueHaasDisplay'] text-[#FFFFFF] leading-[17px] text-center mb-4",
        socialMediaIconColor: "#FFFFFF",
        button:
          "flex font-bold px-[32px] rounded-full font-black font-['Swiss'] justify-center items-center !text-[16px] !h-[52px] bg-[#000000] !text-[#FFFFFF] border-[#FFFFFF] border-[1px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px]  font-['NeueHaasDisplay'] rounded-[6px] border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[14px]",
        emptyState: {
          container:
            "border-[#FFFFFF] border-[1px] sm:w-[500px] w-[95vw] bg-[#000000] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[12px] leading-[20px] text-[#FFFFFF] font-black font-['Swiss'] sm:w-[390px] w-[65vw] text-center",
          text: "text-[12px] font-['NeueHaasDisplay'] text-[#FFFFFF] mb-4",
          button:
            "flex px-[16px] !text-[#FFFFFF] font-black font-['Swiss'] w-fit rounded-full text-bold justify-center items-center !text-[16px] !h-[38px] bg-[#000000] border-[1px] border-[#FFFFFF] text-nowrap cursor-pointer",
        },
        header:
          "text-[20px] font-black font-['Swiss'] uppercase text-[#FFFFFF] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        collapsedEvent: {
          container:
            "h-[64px] rounded-[4px] border-[#FFFFFF] border-[1px] bg-[#000000] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          duration: "text-[12px] font-['NeueHaasDisplay'] text-[#FFFFFF] uppercase",
          name: "text-[12px] leading-[20px] text-[#FFFFFF] font-black font-['Swiss'] sm:w-[390px] w-[65vw]",
          plusIconColor: "#FFFFFF",
          media: "overflow-hidden m-2 rounded-[6px]",
        },
        event: {
          container:
            "overflow-hidden border-[#FFFFFF] rounded-[4px] border-[1px] bg-[#000000] sm:w-[500px] w-[95vw]",
          name: "text-[16px] leading-[20px] mb-1 text-[#FFFFFF] font-black font-['Swiss'] sm:w-[390px] w-[65vw]",
          startDate:
            "!w-[64px] text-[#000000] rounded-[4px] text-[24px] h-[64px] bg-[#FFFFFF] flex flex-col justify-center items-center gap-1 font-black font-['Swiss']",
          duration: "text-[12px] font-['NeueHaasDisplay'] text-[#FFFFFF] uppercase",
          location: "text-[12px] font-['NeueHaasDisplay'] text-[#FFFFFF] mb-4",
          button:
            "flex px-[16px] !text-[#FFFFFF] font-black font-['Swiss'] w-fit rounded-full text-bold justify-center items-center !text-[16px] !h-[38px] bg-[#000000] border-[1px] border-[#FFFFFF] text-nowrap cursor-pointer",
          product: {
            container:
              "h-[74px] border-t border-t-[#FFFFFF] px-4 items-center flex justify-between",
            name: "text-[12px] font-black font-['Swiss'] leading-[20px] mb-1 text-[#FFFFFF] font-bold one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#FFFFFF] font-['NeueHaasDisplay'] text-[12px] uppercase",
            status: "text-[#FFFFFF] text-[12px] uppercase",
            link: "text-[#FFFFFF] text-[12px] uppercase",
            button:
              "flex px-[16px] !text-[#FFFFFF] font-black font-['Swiss'] w-fit rounded-full text-bold justify-center items-center !text-[16px] !h-[38px] bg-[#000000] border-[1px] border-[#FFFFFF] text-nowrap cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[12px] underline font-black font-['Swiss'] text-center text-[#FFFFFF] mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px]  font-['NeueHaasDisplay'] rounded-[6px] border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[14px]",
        header:
          "text-[20px] font-black font-['Swiss'] uppercase text-[#FFFFFF] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden bg-[#FFFFFF] h-[80px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "mt-[2px] text-[12px] font-black font-['Swiss'] leading-[20px] mb-1 font-bold one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[12px] mt-[-7px] font-['NeueHaasDisplay']",
          media: "overflow-hidden h-[48px] w-[48px] ml-4 mr-2 my-4",
        },
        seeAllNews:
          "text-[12px] underline font-black font-['Swiss'] text-center text-[#FFFFFF] mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px]  font-['NeueHaasDisplay'] rounded-[6px] border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[14px]",
        header:
          "text-[20px] font-black font-['Swiss'] uppercase text-[#FFFFFF] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] rounded-[4px] border-[1px] border-[#FFFFFF] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000]",
          name: "text-[12px] font-black font-['Swiss'] leading-[20px] mb-[6px] mt-[8px] one-line-truncate text-[#FFFFFF] font-bold sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#FFFFFF] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default yereyere
